<div class="program-widget">
  <div class="tt-comparison-page" id="tt-comparison-page">
    <div class="tt-page-wrap">
      <section class="tt-site-panel" id="panel-cards">
        <div class="tt-wrap container">


          @if (bestMatchCard && bestMatchCard.programAbbr !== 'tsaprecheck') {
            <div class="tt__best-match" id="best-match-placeholder">
              <h2>{{recommendationTxt | translate}}</h2>
              <p [ngClass]="bestMatchCard ? 'recommendation--' + bestMatchCard.programAbbr : ''" [innerHTML]="bestMatchTxt | translate">
              </p>
            </div>
          }

          @if (bestMatchCard && bestMatchCard.programAbbr == 'tsaprecheck') {
            <div class="tt__best-match" id="best-match-placeholder">
              <h2>{{recommendationTxt | translate}}</h2>
              <div class="recommendation--tsaprecheck">
                <div>TSA PreCheck<sup>&reg;</sup></div>
                <div [innerHTML]="bestMatchTxt | translate"></div>
              </div>
            </div>
          }

          <!-- Best Match Card -->
          @if (bestMatchCard) {
            <div class="tt-card best-match" [ngClass]="{'best-match--promo': isPromoCountry === true}"
              id="{{bestMatchCard.id}}">
              @if (!isPromoCountry) {
                <h2 id="best-match-header" class="best-match-header" translate>HOME.BEST_MATCH_HEADER</h2>
              }
              @if (isPromoCountry) {
                <h2 id="best-match-header" class="best-match-header" translate>HOME.PROMO_COUNTRY_BEST_MATCH_HEADER</h2>
              }
              <div class="tt-card__primary-section">
                <header class="tt-card-header">
                  <h2 class="tt-card-header__primary" [innerHTML]="bestMatchCard.programName | translate"></h2>
                  <div class="tt-price">
                    @if (bestMatchCard.programAbbr == 'tsaprecheck') {
                      <p class="tt-price__amount">{{'MODAL.FROM' | translate}} {{bestMatchCard.price | currency: 'USD': 'symbol'}} <span class="tt-price__currency">USD</span></p>
                    }
                    @if (bestMatchCard.programAbbr != 'tsaprecheck') {
                      <p class="tt-price__amount">{{bestMatchCard.price | currency: 'USD': 'symbol'}} <span class="tt-price__currency">USD</span></p>
                    }
                    <p class="tt-price__description" translate>HOME.BEST_MATCH_RESULTS.MEMBERSHIP_FEE</p>
                    @if (bestMatchCard.programAbbr == 'tsaprecheck') {
                      <p translate>MODAL.NEW_ENROLLMENT</p>
                    }
                  </div>
                </header>
                <div class="tt-card__blocks">
                  <div class="tt-card__block">
                    <h3 class="tt-program-highlight">{{ bestMatchCard.section1.programHighlight  | translate}}</h3>
                    <p>
                      <span [innerHTML]="bestMatchCard.section1.programHighlightDesc | translate"></span>
                      @if (bestMatchCard.programAbbr == 'fast') {
                        <tooltip [tooltip-text] ="'HOME.BEST_MATCH_RESULTS.FAST_PROGRAM_HIGHLIGHT_TOOLTIP'"></tooltip>
                      }
                    </p>
                  </div>
                  @if (bestMatchCard.middleSection) {
                    <div class="tt-card__block">
                      <h3 translate>{{ bestMatchCard.middleSection.header }}</h3>
                      <p [innerHTML]="bestMatchCard.middleSection.text | translate"></p>
                    </div>
                  }
                  <div class="tt-card__block">
                    <h4 translate>HOME.REQUIRED_DOCUMENT</h4>
                    <div class="{{ bestMatchCard.section2.documentClass }}">
                    <img alt="{{ bestMatchCard.section2.imgAlt | translate }}" src="{{ bestMatchCard.section2.imgSrc}}" /></div>
                    <p [innerHTML]="bestMatchCard.section2.imgDescription | translate"></p>
                  </div>
                </div>
                <div class="tt-card__actions">
                  <a [attr.id]="bestMatchCard.cardExpandableId + '-link'" (click)="toggleDetails(bestMatchCard.cardExpandableId)" (keyup.enter)="toggleDetails(bestMatchCard.cardExpandableId)" aria-expanded="false" class="tt-card__toggle" tabindex="0" role="button">
                    <span aria-hidden="true" class="tt-card__toggle__affordance">+</span>
                    <span translate>HOME.BEST_MATCH_RESULTS.VIEW_MORE_DETAILS</span>
                  </a>
                  @if (bestMatchCard.ttpLogin) {
                    <a class="tt-btn tt-enroll-btn" (click)="logSelected(bestMatchCard.programAbbr); logIn();" (keyup.enter)="logSelected(bestMatchCard.programAbbr); logIn();" tabindex="0" role="button" translate>HOME.BEST_MATCH_RESULTS.ENROLL_NOW</a>
                  }
                  @if (!bestMatchCard.ttpLogin) {
                    <a class="tt-btn tt-enroll-btn" [attr.href]="bestMatchCard.actionHref" (click)="logSelected(bestMatchCard.programAbbr);" (keyup.enter)="logSelected(bestMatchCard.programAbbr);"
                    target="_blank" tabindex="0" role="button" translate>HOME.BEST_MATCH_RESULTS.ENROLL_NOW</a>
                  }
                </div>
              </div>
              <div class="tt-card__secondary-section collapsed" [attr.id]="bestMatchCard.cardExpandableId">
                <div class="tt-card__blocks">
                  <div class="tt-card__block">
                    <h3 translate>HOME.BEST_MATCH_RESULTS.APPLICATION_PROCESS_TEXT</h3>
                    <div class="application-process">
                      <div class="application-process__item1">
                        <i class="fa fa-desktop circle_for_fa" aria-hidden="true"></i>
                        <h4 translate>HOME.BEST_MATCH_RESULTS.VIEW_MORE_CARD_APPLY_HEADER</h4>
                        @if (bestMatchCard.ttpLogin) {
                          <p>{{ 'HOME.BEST_MATCH_RESULTS.VIEW_MORE_CARD_APPLY' |
                            translate}} <a (click)="logSelected(bestMatchCard.programAbbr); logIn();" (keyup.enter)="logSelected(bestMatchCard.programAbbr); logIn();" tabindex="0" role="button" translate>HOME.BEST_MATCH_RESULTS.ONLINE</a>.
                          </p>
                        }
                        @if (!bestMatchCard.ttpLogin) {
                          <p translate>{{ 'HOME.BEST_MATCH_RESULTS.VIEW_MORE_CARD_APPLY' |
                            translate}} <a target="_blank" href="{{ bestMatchCard.appProcessHref }}" (click)="logSelected(bestMatchCard.programAbbr);" (keyup.enter)="logSelected(bestMatchCard.programAbbr);" tabindex="0" translate>HOME.BEST_MATCH_RESULTS.ONLINE</a>.</p>
                          }
                        </div>
                        <div class="application-process__item2">
                          <i class="fa fa-user circle_for_fa" aria-hidden="true"></i>
                          <h4 translate>HOME.BEST_MATCH_RESULTS.VIEWMORE_CARD_INTERVIEW_HEADER</h4>
                          @if (bestMatchCard.programAbbr !== 'global-entry') {
                            <p translate>HOME.BEST_MATCH_RESULTS.VIEWMORE_CARD_INTERVIEW</p>
                          }
                          @if (bestMatchCard.programAbbr == 'global-entry') {
                            <p translate>HOME.BEST_MATCH_RESULTS.VIEWMORE_CARD_INTERVIEW_UP</p>
                          }
                          @if (bestMatchCard.programAbbr == 'global-entry') {
                            <p>
                              <!--/* //NOSONAR */--><a tabindex="0" href="https://www.cbp.gov/travel/trusted-traveler-programs/global-entry/enrollment-arrival"
                            target="_blank" rel="noopener" translate>HOME.BEST_MATCH_RESULTS.FIND_EOA_LOCATION</a>
                          </p>
                        }
                        @if (bestMatchCard.programAbbr !== 'fast') {
                          <p>
                            @if (bestMatchCard.programAbbr !== 'nexus') {
                              <a tabindex="0" href="{{ bestMatchCard.findEnrollmentCenterLink }}"
                              target="_blank" translate>HOME.BEST_MATCH_RESULTS.FIND_ENROLLMENT_CENTER</a>
                            }
                            @if (bestMatchCard.programAbbr == 'nexus') {
                              <a tabindex="0" href="{{ bestMatchCard.findEnrollmentCenterLink }}"
                              target="_blank" translate>HOME.BEST_MATCH_RESULTS.FIND_ENROLLMENT_CENTER_NX</a>
                            }
                          </p>
                        }
                        @if (bestMatchCard.programAbbr == 'fast') {
                          <div>
                            <br>
                              <p>
                                <span translate>HOME.BEST_MATCH_RESULTS.ENROLLMENT_CENTERS</span>:<br>
                                <a tabindex="0" [attr.href]="this.schedulerViewLocationsUrl + 'fs'" target="_blank" translate>HOME.BEST_MATCH_RESULTS.ENROLLMENT_CENTERS_US_MEXICO</a>
                                <a tabindex="0" [attr.href]="this.schedulerViewLocationsUrl + 'fn'" target="_blank" translate>HOME.BEST_MATCH_RESULTS.ENROLLMENT_CENTERS_US_CANADA</a>
                              </p>
                            </div>
                          }
                        </div>
                        <div class="application-process__item3">
                          <i class="far fa-id-card circle_for_fa" aria-hidden="true"></i>
                          <h4 translate>HOME.BEST_MATCH_RESULTS.VIEWMORE_CARD_MEMBERSHIP_HEADER</h4>
                          <p translate>HOME.BEST_MATCH_RESULTS.VIEWMORE_CARD_MEMBERSHIP</p>
                        </div>
                      </div>
                      <p><em [innerHTML]="bestMatchCard.membershipNote | translate"></em></p>
                      <h3 translate>HOME.BEST_MATCH_RESULTS.ELIGIBLITY</h3>
                      @if (bestMatchCard.programAbbr === 'global-entry') {
                        <p translate>{{ globalTravelEligibilityTxt }}</p>
                      }
                      @if (bestMatchCard.programAbbr !== 'global-entry') {
                        <p translate>{{ bestMatchCard.eligibility }}</p>
                      }
                      @if (bestMatchCard.programAbbr === 'tsaprecheck') {
                        <p>
                          <a target="_blank" [attr.href]="bestMatchCard.learnMoreLink" target="_blank" [innerHTML]="'HOME.BEST_MATCH_RESULTS.TSAPRE_LEARNMORE_AT' | translate"></a>
                        </p>
                      }
                      @if (bestMatchCard.programAbbr !== 'tsaprecheck') {
                        <p>
                          <!-- <a target="_blank" [attr.href]="bestMatchCard.learnMoreLink" target="_blank" translate [translateParams]="{value: bestMatchCard.programName}">HOME.BEST_MATCH_RESULTS.LEARNMORE_AT</a> -->
                          <a target="_blank" [attr.href]="bestMatchCard.learnMoreLink" target="_blank">{{ 'HOME.BEST_MATCH_RESULTS.LEARNMORE_AT' | translate: {value: bestMatchCard.programName} }}</a>
                        </p>
                      }
                    </div>
                    <div class="tt-card__block">
                      <h3 translate>HOME.BEST_MATCH_RESULTS.FEATURED_BENEFITS</h3>
                      <ul class="tt-featured-benefits">
                        @for (fb of bestMatchCard.featuredBenefits; track fb) {
                          <li class="tt-featured-benefits__item">
                            <span [innerHTML]="fb.benefit | translate"></span>
                            @if (fb.tooltip) {
                              <tooltip class="no-float" [tooltip-text] ="fb.tooltip"></tooltip>
                            }
                          </li>
                        }
                      </ul>
                      @if (bestMatchCard.additionalBenefits) {
                        <h3 translate>HOME.BEST_MATCH_RESULTS.ADDITIONAL_BENEFITS</h3>
                      }
                      @if (bestMatchCard.additionalBenefits) {
                        <ul>
                          @for (ab of filterExclusionsFromBenefits(bestMatchCard.programAbbr); track ab) {
                            <li>
                              <span [innerHTML]="ab.text | translate"></span>
                              @if (ab.tooltip) {
                                <tooltip class="no-float" [tooltip-text] ="ab.tooltip"></tooltip>
                              }
                            </li>
                          }
                        </ul>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }


            @if (bestMatchCard && cards.length >= 1) {
              <div>
                <h2 class="other-programs-header" id="other-programs-header" translate>HOME.OTHERPROGRAMS_BESTMATCH_TEXT</h2>
              </div>
            }
            <div class="tt-cards" id="sortableCards">

              <!-- Other Programs -->
              <!-- <div *ngFor="let card of cards; let i = index"> -->
              @for (card of cards; track card; let i = $index) {
                <div class="tt-card" id="{{card.id}}" [ngClass]="otherProgramsClass">
                  <div class="tt-card__primary-section">
                    <header class="tt-card-header">
                      <h2 class="tt-card-header__primary" [innerHTML]="card.programName | translate"></h2>
                      <div class="tt-price">
                        @if (card.programAbbr == 'tsaprecheck') {
                          <p class="tt-price__amount">{{'MODAL.FROM' | translate}} {{card.price | currency: 'USD': 'symbol'}} <span class="tt-price__currency">USD</span></p>
                        }
                        @if (card.programAbbr != 'tsaprecheck') {
                          <p class="tt-price__amount">{{card.price | currency: 'USD': 'symbol'}} <span class="tt-price__currency">USD</span></p>
                        }
                        <p class="tt-price__description" translate>HOME.BEST_MATCH_RESULTS.MEMBERSHIP_FEE</p>
                        @if (card.programAbbr === 'tsaprecheck') {
                          <p translate>MODAL.NEW_ENROLLMENT</p>
                        }
                      </div>
                    </header>
                    <div class="tt-card__blocks">
                      <div class="tt-card__block">
                        <h3 class="tt-program-highlight" [innerHTML]="card.section1.programHighlight | translate"></h3>
                        <p>
                          <span [innerHTML]="card.section1.programHighlightDesc | translate"></span>
                          @if (card.programAbbr == 'fast') {
                            <tooltip [tooltip-text] ="'HOME.BEST_MATCH_RESULTS.FAST_PROGRAM_HIGHLIGHT_TOOLTIP'"></tooltip>
                          }
                        </p>
                      </div>
                      @if (card.middleSection) {
                        <div class="tt-card__block">
                          <h3 translate>{{ card.middleSection.header }}</h3>
                          <p [innerHTML]="card.middleSection.text | translate"></p>
                        </div>
                      }
                      <div class="tt-card__block">
                        <h4 translate>HOME.REQUIRED_DOCUMENT</h4>
                        <div class="{{ card.section2.documentClass }}">
                        <img alt="{{ card.section2.imgAlt | translate }}" src="{{ card.section2.imgSrc }}" /></div>
                        <p [innerHTML]="card.section2.imgDescription | translate"></p>
                      </div>
                    </div>
                    <div class="tt-card__actions">
                      <a [attr.id]="card.cardExpandableId + '-link'" (click)="toggleDetails(card.cardExpandableId)" (keyup.enter)="toggleDetails(card.cardExpandableId)" aria-expanded="false" class="tt-card__toggle" tabindex="0" role="button">
                        <span aria-hidden="true" class="tt-card__toggle__affordance">+</span>
                        <span translate>HOME.BEST_MATCH_RESULTS.VIEW_MORE_DETAILS</span>
                      </a>
                      @if (card.ttpLogin) {
                        <a class="tt-btn tt-enroll-btn" (click)="logSelected(card.programAbbr); logIn();" (keyup.enter)="logSelected(card.programAbbr); logIn();" tabindex="0" role="button" translate>HOME.BEST_MATCH_RESULTS.ENROLL_NOW</a>
                      }
                      @if (!card.ttpLogin) {
                        <a class="tt-btn tt-enroll-btn" (click)="logSelected(card.programAbbr);" (keyup.enter)="logSelected(card.programAbbr);" [attr.href]="card.actionHref" target="_blank" tabindex="0" role="button"
                        translate>HOME.BEST_MATCH_RESULTS.ENROLL_NOW</a>
                      }
                    </div>
                  </div>
                  <div class="tt-card__secondary-section collapsed" [attr.id]="card.cardExpandableId">
                    <div class="tt-card__blocks">
                      <div class="tt-card__block">
                        <h3 translate>HOME.BEST_MATCH_RESULTS.APPLICATION_PROCESS_TEXT</h3>
                        <div class="application-process">
                          <div class="application-process__item1">
                            <i class="fa fa-desktop circle_for_fa" aria-hidden="true"></i>
                            <h4 translate>HOME.BEST_MATCH_RESULTS.VIEW_MORE_CARD_APPLY_HEADER</h4>
                            @if (card.ttpLogin) {
                              <p translate>{{ 'HOME.BEST_MATCH_RESULTS.VIEW_MORE_CARD_APPLY' |
                                translate}} <a (click)="logSelected(card.programAbbr); logIn();" (keyup.enter)="logSelected(card.programAbbr); logIn();" tabindex="0" role="button" translate>HOME.BEST_MATCH_RESULTS.ONLINE</a>.</p>
                              }
                              @if (!card.ttpLogin) {
                                <p translate>{{ 'HOME.BEST_MATCH_RESULTS.VIEW_MORE_CARD_APPLY' |
                                  translate}} <a target="_blank" href="{{ card.appProcessHref }}" (click)="logSelected(card.programAbbr);" (keyup.enter)="logSelected(card.programAbbr);" translate>HOME.BEST_MATCH_RESULTS.ONLINE</a>.</p>
                                }
                              </div>
                              <div class="application-process__item2">
                                <i class="fa fa-user circle_for_fa" aria-hidden="true"></i>
                                <h4 translate>HOME.BEST_MATCH_RESULTS.VIEWMORE_CARD_INTERVIEW_HEADER</h4>
                                @if (card.programAbbr !== 'global-entry') {
                                  <p translate>HOME.BEST_MATCH_RESULTS.VIEWMORE_CARD_INTERVIEW</p>
                                }
                                @if (card.programAbbr == 'global-entry') {
                                  <p translate>HOME.BEST_MATCH_RESULTS.VIEWMORE_CARD_INTERVIEW_UP</p>
                                }
                                @if (card.programAbbr == 'global-entry') {
                                  <p>
                                    <!--/* //NOSONAR */--><a tabindex="0" href="https://www.cbp.gov/travel/trusted-traveler-programs/global-entry/enrollment-arrival"
                                  target="_blank" rel="noopener" translate>HOME.BEST_MATCH_RESULTS.FIND_EOA_LOCATION</a><br>
                                </p>
                              }
                              <p>
                                @if (card.programAbbr !== 'nexus') {
                                  <a href="{{ card.findEnrollmentCenterLink }}" tabindex="0" target="_blank"
                                  translate>HOME.BEST_MATCH_RESULTS.FIND_ENROLLMENT_CENTER</a>
                                }
                                @if (card.programAbbr == 'nexus') {
                                  <a href="{{ card.findEnrollmentCenterLink }}" tabindex="0" target="_blank"
                                  translate>HOME.BEST_MATCH_RESULTS.FIND_ENROLLMENT_CENTER_NX</a>
                                }
                              </p>
                            </div>
                            <div class="application-process__item3">
                              <i class="far fa-id-card circle_for_fa" aria-hidden="true"></i>
                              <h4 translate>HOME.BEST_MATCH_RESULTS.VIEWMORE_CARD_MEMBERSHIP_HEADER</h4>
                              <p translate>HOME.BEST_MATCH_RESULTS.VIEWMORE_CARD_MEMBERSHIP</p>
                            </div>
                          </div>
                          <p><em [innerHTML]="card.membershipNote | translate"></em></p>
                          <h3 translate>HOME.BEST_MATCH_RESULTS.ELIGIBLITY</h3>
                          @if (card.programAbbr === 'global-entry') {
                            <p translate>{{ globalTravelEligibilityTxt }}</p>
                          }
                          @if (card.programAbbr !== 'global-entry') {
                            <p translate>{{ card.eligibility }}</p>
                          }
                          @if (card.programAbbr === 'tsaprecheck') {
                            <p>
                              <a target="_blank" [attr.href]="card.learnMoreLink" target="_blank" [innerHTML]="'HOME.BEST_MATCH_RESULTS.TSAPRE_LEARNMORE_AT' | translate"></a>
                            </p>
                          }
                          @if (card.programAbbr !== 'tsaprecheck') {
                            <p>
                              <!-- <a target="_blank" [attr.href]="card.learnMoreLink" target="_blank" translate [translateParams]="{value: card.programName}">HOME.BEST_MATCH_RESULTS.LEARNMORE_AT</a> -->
                              <a target="_blank" [attr.href]="card.learnMoreLink" target="_blank">{{ 'HOME.BEST_MATCH_RESULTS.LEARNMORE_AT' | translate: {value: card.programName} }}</a>
                            </p>
                          }
                        </div>
                        <div class="tt-card__block">
                          <h3 translate>HOME.BEST_MATCH_RESULTS.FEATURED_BENEFITS</h3>
                          <ul class="tt-featured-benefits">
                            @for (fb of card.featuredBenefits; track fb) {
                              <li class="tt-featured-benefits__item">
                                <span [innerHTML]="fb.benefit | translate"></span>
                                @if (fb.tooltip) {
                                  <tooltip class="no-float" [tooltip-text] ="fb.tooltip"></tooltip>
                                }
                                <!-- <span class="infoIcon"><a aria-expanded="false" aria-label="Show infoIcon" class="infoIcon__icon" href="#">i</a><span class="infoIcon__text"> </span></span>  -->
                              </li>
                            }
                          </ul>
                          @if (card.additionalBenefits) {
                            <h3 translate>HOME.BEST_MATCH_RESULTS.ADDITIONAL_BENEFITS</h3>
                          }
                          @if (card.additionalBenefits) {
                            <ul>
                              @for (ab of filterExclusionsFromBenefits(card.programAbbr); track ab) {
                                <li>
                                  <span [innerHTML]="ab.text | translate"></span>
                                  @if (ab.tooltip) {
                                    <tooltip class="no-float" [tooltip-text] ="ab.tooltip"></tooltip>
                                  }
                                </li>
                              }
                            </ul>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              <!-- </div> -->

            </div>
          </div>
        </section>
      </div>
      <!--
      <div class="return-button row row-centered">
        <div class="col-xs-12 col-centered" style="margin-bottom: 0px;">
          <a tabindex="0" id="return-button" (click)="returnHome();" (keydown.enter)="returnHome();"  class="btn btn-info widget-button">Return</a>
        </div>
      </div> -->
    </div>
  </div>
